import axios from 'axios';
import { cookie } from '../utils/util'


/**
 * 创建
 */
const service = axios.create({
  baseURL:  process.env.API_DOMAIN  ,
  timeout: 60000,
});

/**
 * 请求拦截器
 */
service.interceptors.request.use(
  //在发送之前
  function(config){
    // 带上cookie
    const cookieVal = cookie('csrftoken');
    // console.log('cookie' , cookieVal);
    
    if (cookieVal) {
      config.headers['X-CSRF-Token'] = cookieVal;
    }
    return config;
  },
  //对请求错误
  function(error){
    return Promise.reject(error);
  }

);

/**
 * 响应拦截器
 */
service.interceptors.response.use(
  function (config) {

    // 对响应数据做点什么
    return config;
  },
  function (error) {
    alert("连接服务器出错");
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/service/fetch.js